import type { Blockchain, OrderId } from "@rarible_int/anaconda_sdk/ethereum"
import { useMolecule } from "bunshi/react"
import { useCallback, useMemo } from "react"
import { useSwitchEvmChain } from "../../use-switch-evm-chain"
import { CancelByOrderTransactionMoleculeReatom } from "./evm-cancel-by-order-molecule.reatom"

export function useEvmCancelByOrder(orderId: OrderId, blockchain: Blockchain) {
  const { cancelByOrderActionFactory } = useMolecule(
    CancelByOrderTransactionMoleculeReatom,
  )
  const cancelByOrderAction = useMemo(() => {
    return cancelByOrderActionFactory()
  }, [cancelByOrderActionFactory])

  const onSuccess = useCallback(() => {
    cancelByOrderAction({ orderId, blockchain })
  }, [cancelByOrderAction, orderId, blockchain])

  const { action, switchInProgress } = useSwitchEvmChain<void>(
    blockchain,
    onSuccess,
  )

  return {
    mutate: action,
    cancelByOrderAction,
    switchInProgress,
    isPending: !!cancelByOrderAction.pending() || switchInProgress,
  }
}
